export const contractors = 'performer-rating/performers';
export const contractor = (uuid:string) => `performer-rating/performer/${uuid}`
export const reviewContractor = (uuid:string) => `performer-rating/opinion/${uuid}`
